<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 16 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" :fill="fill" r="8"/>
    <path clip-rule="evenodd" d="M12 8C12 10.2091 10.2091 12 8 12C7.05119 12 6.17954 11.6697 5.49379 11.1177L11.1177 5.49379C11.6697 6.17954 12 7.05119 12 8ZM4.79866 10.3986L10.3986 4.79866C9.73032 4.29714 8.89986 4 8 4C5.79086 4 4 5.79086 4 8C4 8.89986 4.29714 9.73032 4.79866 10.3986ZM13 8C13 10.7614 10.7614 13 8 13C5.23858 13 3 10.7614 3 8C3 5.23858 5.23858 3 8 3C10.7614 3 13 5.23858 13 8Z" :fill="iconFill" fill-rule="evenodd"/>
  </svg>
</template>

<script>
export default {
  name: 'NoSale',
  props: {
    width: {
      type: String,
      required: false,
      default: '16'
    },
    height: {
      type: String,
      required: false,
      default: '16'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#737373'
    },
    iconFill: {
      type: String,
      required: false,
      default: '#FFF'
    },
  },
};
</script>
